import React from 'react'

import { theme } from '@components/Theme'

import { Svg } from './Svg'

export interface SecurityComplexProps {
  color?: string
  hoverColor?: string
  className?: string
  size?: string | number
}

export function SecurityComplex({ color = theme.colors.greys.mineshaft, hoverColor, className, size = '100%' }: SecurityComplexProps): JSX.Element {
  return (
    <Svg
      $strokeColor={color}
      $strokeHoverColor={hoverColor}
      $fillColor={color}
      $fillHoverColor={hoverColor}
      className={className}
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g transform="scale(1.08) translate(-5,-5)">
        <g id="Layer_1">
          <g>
            <path d="M32,62.8c-2.3,1.8-4.2,2.5-6.1.5-1.5-1.6-1-3.6,1.2-5.8,12.6-12.6,25.2-25.2,37.8-37.7,3.7-3.7,7.5-3.7,11.2,0,3.8,3.8,7.6,7.6,11.9,11.8,0-3.2,0-5.7,0-8.3,0-2.9,1.2-4.1,4-4.2,2,0,3.9,0,5.9,0,2.9.1,4,1.3,4.1,4.5,0,6.6,0,13.2,0,19.8,0,1.3.7,2.8,1.6,3.8,3.2,3.5,6.7,6.8,10.1,10.1,1.7,1.7,3.2,3.4,1.5,5.8-1.7,2.2-3.7,1.5-6,0,0,1.2-.2,2.2-.2,3.1,0,10.4,0,20.9,0,31.3,0,8.4-4,12.4-12.3,12.4-17.4,0-34.9,0-52.3,0-8.4,0-12.3-4-12.3-12.3,0-11.5,0-22.9,0-34.8Z" fill={color} />
            <path d="M59,15.9c-4.5,4.4-8.4,8.2-12.3,12.1-8.2,8.2-16.5,16.5-24.7,24.7-6.1,6.1-5.3,13.1,1.8,17.8.7.5,1.1,1.8,1.2,2.7,0,9.8,0,19.5,0,29.3-7.7,1.9-13.9-2.9-14-11.2-.1-10.6,0-21.2,0-31.9,0-1,0-2,0-3-.3-.1-.6-.3-.6-.3-2,1.4-4,1.9-5.6-.3-1.7-2.2-.3-4,1.3-5.6,12.6-12.6,25.2-25.1,37.8-37.7,3.7-3.7,7.5-3.7,11.2,0,1.1,1.1,2.4,2,3.9,3.2Z" fill={color || '#222'} />
          </g>
        </g>
      </g>
    </Svg>
  )
}
